<template>
    <div style="text-align: left !important;">
        <h1>Taula de seguidors/comptadors</h1>
        <p>Pots descarregar-te un document amb la configuració dels seguidors i els comptadors associats:</p>
        <b-button href="/docs/plantes.pdf" target="_blank">Descarregar</b-button>
        <hr>
        <h1>Descarrega de totes les lectures</h1>
        <p>Descarrega totes les lectures (tot l'històric) de tots els seguidors. Pot trigar una estona.</p>
        <b-button v-b-modal.modal-download>
            Descarregar
        </b-button>

        <div>
            <b-modal id="modal-download" title="Descarregar lectures dels seguidors"
                     ok-title="Descarregar"
                     cancel-title="Tancar"
                     :ok-disabled="downloadingReadings"
                     :cancel-disabled="downloadingReadings"
                     hide-header-close
                     v-on:ok="downloadReadings">

                <p class="my-4">Introdueix les dates d'inici i final del període i prem al botó de
                    <strong>Descarregar</strong>
                </p>
                Inici:
                <b-form-input type="date" v-model="downloadDateStart"></b-form-input>
                Final:
                <b-form-input type="date" v-model="downloadDateEnd"></b-form-input>
                <br/>
                <b-alert variant="danger" :show="incorrectRange">El rang de dates és incorrecte.</b-alert>
                <b-spinner v-show="downloadingReadings"></b-spinner>
            </b-modal>
        </div>
    </div>
</template>

<script>
    import Api from "../api"

    export default {
        name: "UtilsView",
        data: function () {
            return {
                downloadDateStart: null,
                downloadDateEnd: null,
                downloadingReadings: false,
                incorrectRange: false
            }
        },
        methods: {
            downloadReadings(bvModalEvt) {

                bvModalEvt.preventDefault()

                this.incorrectRange = (!this.downloadDateStart || !this.downloadDateEnd)
                this.incorrectRange = this.incorrectRange || (this.downloadDateEnd < this.downloadDateStart)
                if (this.incorrectRange) {
                    return
                }

                this.downloadingReadings = true

                Api.allReadingsDownload(this.downloadDateStart, this.downloadDateEnd)
                    .then(({data}) => {
                        let blob = new Blob([data], {type: data.type})
                        let link = document.createElement('a')
                        link.href = window.URL.createObjectURL(blob)
                        link.download = 'totes-lectures-seguidors.csv'
                        link.click()
                        this.downloadingReadings = false
                    })
                    .catch(({error}) => {
                        window.console.log(error)
                        this.downloadingReadings = false
                    })
            },
        }
    }
</script>

<style scoped>
</style>